import {
  DownloadTeamExcelRequest,
  UploadTeamExcelRequest,
  ViewTeamLeaderboardRequest,
  ViewTeamsForProgrammeRequest
} from './programme-teams.types';

import { API_HOST, HttpGetOptions, HttpPostOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = (externalReference: string) => `${API_HOST}/programme/${externalReference}/teams`;

export const getViewTeamsForProgrammeRequest = (data: ViewTeamsForProgrammeRequest): [string, HttpGetOptions] => [
  getEndpoint(data.programmeExternalReference),
  getHttpGetOptions()
];

export const getDownloadTeamExcelRequest = (data: DownloadTeamExcelRequest): [string, HttpGetOptions] => [
  `${getEndpoint(data.programmeExternalReference)}/download`,
  getHttpGetOptions()
];

export const getUploadTeamExcelRequest = (
  data: UploadTeamExcelRequest
): [string, HttpPostOptions<{ data: string }>] => [
  `${getEndpoint(data.programmeExternalReference)}/upload`,
  getHttpPostOptions({ data: data.data })
];

export const getViewTeamLeaderboardRequest = (data: ViewTeamLeaderboardRequest): [string, HttpGetOptions] => [
  `${getEndpoint(data.programmeExternalReference)}/leaderboard`,
  getHttpGetOptions()
];
